export default __webpack_public_path__ + "static/media/AKA07141701_7415@3x.b2113915.png";